__webpack_require__.p = "https://www.assemblageworld.com/";